export type ThemeChoice = 'light' | 'dark';

const STORAGE_KEY = 'ssn-theme';

export function currentTheme(): ThemeChoice {
  const attribute = document.documentElement.dataset['theme'];
  return attribute === 'dark' ? 'dark' : 'light';
}

export function setTheme(theme: ThemeChoice): void {
  document.documentElement.dataset['theme'] = theme;
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // A browser with storage blocked still gets the theme for this session.
  }
}

export function toggleTheme(): ThemeChoice {
  const next: ThemeChoice = currentTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}
